/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Segment_Event_Group_By_QuantityInputs */

const en_segment_event_group_by_quantity = /** @type {(inputs: Segment_Event_Group_By_QuantityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`By Number of Events`)
};

const fr_segment_event_group_by_quantity = /** @type {(inputs: Segment_Event_Group_By_QuantityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Par nombre d'evenements`)
};

const de_segment_event_group_by_quantity = /** @type {(inputs: Segment_Event_Group_By_QuantityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nach Anzahl der Ereignisse`)
};

const it_segment_event_group_by_quantity = /** @type {(inputs: Segment_Event_Group_By_QuantityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Per numero di eventi`)
};

const ru_segment_event_group_by_quantity = /** @type {(inputs: Segment_Event_Group_By_QuantityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`По количеству событий`)
};

const es_segment_event_group_by_quantity = /** @type {(inputs: Segment_Event_Group_By_QuantityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por número de eventos`)
};

const zh_cn2_segment_event_group_by_quantity = /** @type {(inputs: Segment_Event_Group_By_QuantityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`按事件数量`)
};

const ja_segment_event_group_by_quantity = /** @type {(inputs: Segment_Event_Group_By_QuantityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベント数別`)
};

const hi_segment_event_group_by_quantity = /** @type {(inputs: Segment_Event_Group_By_QuantityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आयोजनों की संख्या के अनुसार`)
};

const pt_pt2_segment_event_group_by_quantity = /** @type {(inputs: Segment_Event_Group_By_QuantityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por número de eventos`)
};

/**
* | output |
* | --- |
* | "By Number of Events" |
*
* @param {Segment_Event_Group_By_QuantityInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const segment_event_group_by_quantity = /** @type {((inputs?: Segment_Event_Group_By_QuantityInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Segment_Event_Group_By_QuantityInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_segment_event_group_by_quantity(inputs)
	if (locale === "de") return de_segment_event_group_by_quantity(inputs)
	if (locale === "it") return it_segment_event_group_by_quantity(inputs)
	if (locale === "ru") return ru_segment_event_group_by_quantity(inputs)
	if (locale === "es") return es_segment_event_group_by_quantity(inputs)
	if (locale === "zh-CN") return zh_cn2_segment_event_group_by_quantity(inputs)
	if (locale === "ja") return ja_segment_event_group_by_quantity(inputs)
	if (locale === "hi") return hi_segment_event_group_by_quantity(inputs)
	if (locale === "pt-PT") return pt_pt2_segment_event_group_by_quantity(inputs)
	return en_segment_event_group_by_quantity(inputs)
});